import styled from 'styled-components'
import { StyledTabs } from '~/components/Tabs'
import { MediaBreakPointUp } from '~/theme'

export const StyledOrderListWrapper = styled.div`
  align-items: flex-start;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  margin: 0 auto 16px auto;
  max-width: 435px;
  padding: 20px 0 0 0;
  position: relative;
  overflow: hidden;
  border: 0.5px solid #e7e2ff;

  @media screen and (max-width: ${MediaBreakPointUp.sm}) {
    width: calc(100% - 30px);
    box-sizing: border-box;
  }
`

export const StyledOrderList = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 8px 0;
  width: 100%;

  background:
		/* Shadow covers */ linear-gradient(
      white 30%,
      rgba(255, 255, 255, 0)
    ),
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
    /* Shadows */
      radial-gradient(
        farthest-side at 50% 0,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      ),
    radial-gradient(
        farthest-side at 50% 100%,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;

  /* Opera doesn’t support this in the shorthand */
  background-attachment: local, local, scroll, scroll;
`

export const StyledOrder = styled.div`
  border-bottom: 1px solid #eff0fa;
  padding: 24px 0;
  width: calc(100% - 30px);
  margin: 0 15px;
  box-sizing: border-box;

  &:last-of-type {
    border-bottom: none;
  }

  &:first-of-type {
    padding-top: 5px;
  }
`

export const StyledTokens = styled.div`
  color: #191c1e;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  line-height: 140%;
  margin-bottom: 8px;

  img {
    margin: 0 8px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 4px;
  width: 100%;

  .label {
    color: #6f7390;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.242667px;
    line-height: 140%;
  }

  .value {
    color: #2c2842;
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
  }

  .lon-tooltip {
    margin-left: auto;
  }
`

export const OrderStatus = styled.div`
  color: #6f7390;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  white-space: nowrap;

  &.expired {
    color: #d05353;
  }

  &.fulfilled {
    color: #4dbc9b;
  }
`

export const OrderNote = styled.div`
  background: #fffae9;
  border: 0.5px solid #f3e7c7;
  border-radius: 12px;
  color: #928761;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 8px;
  padding: 8px 12px;
`

export const CancelButton = styled.button`
  background: transparent;
  border: 0.5px solid #9598ab;
  border-radius: 24px;
  cursor: pointer;
  color: #191c1e;
  font-size: 12px;
  font-weight: 500;
  line-height: 140%;
  margin-top: 8px;
  padding: 8px 20px;
`

export const StyledEmptyOrder = styled.div`
  color: #e9e9e9;
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
  margin: 35px auto 28px;
  text-align: center;
  width: 64px;

  .note {
    margin-top: 8px;
  }
`

export const OrderTabs = styled(StyledTabs)`
  background: #fff;
  width: 100%;
  padding-left: 1em;
  padding-bottom: 1em;
`
